import React from "react";
import Button from "../Button";
import s from "./InputField.module.css";
import { SVGIconColors } from "../SVGIcon/SVGIcon";
type UnionInputFieldType = ["text", "password", "email"];

const UnionIcon = ["search", "burgundyorangeclose"] as const;

export default function InputField({
    label,
    type,
    icon,
    className,
    iconColor,
    placeholder,
    onChange,
    value,
    onSubmit,
    onButtonSubmit = (e) => e.preventDefault,
    ...props
}: {
    label?: string;
    type: UnionInputFieldType[number];
    icon?: (typeof UnionIcon)[number];
    className?: string | object;
    placeholder: string;
    value: string;
    iconColor?: (typeof SVGIconColors)[number];
    onSubmit?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onButtonSubmit: (e: React.ChangeEvent<HTMLButtonElement>) => void;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}): React.ReactNode {
    return (
        <div className={`${s.container} ${className}`}>
            {label && <label className={s.label}>{label}</label>}
            <input
                className={`${s.input}`}
                type={type}
                placeholder={placeholder}
                {...props}
                onChange={onChange}
                value={value}
                onSubmit={onSubmit}
            />
            {icon && (
                <div className={s.iconContainer}>
                    <Button
                        onClick={onButtonSubmit}
                        variant="icon-only"
                        iconColor={iconColor}
                        icon={icon}
                    />
                </div>
            )}
        </div>
    );
}
